import {
  Autocomplete,
  Avatar,
  Backdrop,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Grid,
  InputLabel,
  List,
  ListItem,
  Paper,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../components/Maincard";
import { DataGrid } from "@mui/x-data-grid";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import InfoCard from "../../newTestPrep/pages/Events/InfoCard";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import EmailIcon from "@mui/icons-material/Email";
import { fDate, fDateTime } from "../../utils/formatTime";
import CustomPopup from "../../components/CustomPopup";
import NoenquiryForm from "../../newTestPrep/components/DataTransferComp.jsx/NoenquiryForm";

import NoeMailForm from "../../newTestPrep/components/DataTransferComp.jsx/NoMailForm";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import CampaignReportFilter from "./CampaignReportFilter";
import { CSVExport } from "../../newTestPrep/components/ui-component/table/CSVExport";
import { useGetTokenOrLogout } from "../../utils/token";
import MassTaskAssign from "../../newTestPrep/components/DataTransferComp.jsx/MassTaskAssign";
import BulkEmailPopup from "../../newTestPrep/components/BulkEmail/BulkEmailPopup";
import BulkMailform from "../../newTestPrep/components/BulkEmail/BulkMailform";
import FilterButtonComponent from "../../newTestPrep/newComponent/NewButtonComp/FilterButtonComponent";
import MassTaskAssignButton from "../../newTestPrep/newComponent/NewButtonComp/MassTaskAssignButton";
import SendEmailButton from "../../newTestPrep/newComponent/NewButtonComp/SendEmailButton";
import SelectedItemButton from "../../newTestPrep/newComponent/NewButtonComp/SelectedItemButton";
import SearchTextFieldComp from "../../newTestPrep/newComponent/newtextfieldComp/SearchTextFieldComp";
import HeadingCard from "../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import LoaderComp from "../../newTestPrep/newComponent/LoaderComp/Loader";
import OutlinedButtonComp from "../../newTestPrep/newComponent/OutlinedButtonComp";

export default function CampaignDetailedReport({ open }) {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");

  const getTokenOrLogout = useGetTokenOrLogout();

  const [openSumReport, setSumReporrt] = useState(true);

  const [campaignLoading, setCampaignLoading] = useState(false);

  const [campaignreportData, setCampaignreportData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [campaignRowData, setcampaignRowData] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [selectedid, setSelectedid] = useState([]);
  const [selectedEnquiryId, setSelectedEnquiryids] = useState([]);
  const [openMask, setOpenMask] = useState(false);
  const [OpenEmailPopup, setOpenEmailPopup] = useState(false);

  const [isDownloadAccess, setIsDownloadAccess] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 100,
  });

  const [visibleRowIds, setVisibleRowIds] = useState([]); // Store current page's row IDs
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [prevPageSize, setPrevPageSize] = useState(pagination.pageSize);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [openstatus, setOpenStatus] = useState(false);
  const [openstages, setOpenStages] = useState(false);
  const [levalStatus, setLevalStatus] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [gridKey, setGridKey] = useState(0);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const navigate = useNavigate();

  // const handleToggle = () => {
  //   setOpen(!open);
  // };

  const handleTogglesumReport = () => {
    setSumReporrt(!openSumReport);
  };

  // Upadate current page ids when pagination is chnages
  useEffect(() => {
    setPrevPageSize(pagination.pageSize);

    // new pagesize is less than prev page size then deselct all selected ids first
    if (pagination.pageSize !== prevPageSize) {
      setSelectedid([]);
      return;
    }

    // Update visible row IDs when pagination changes
    const currentPageRows = campaignreportData.slice(
      pagination.page * pagination.pageSize,
      (pagination.page + 1) * pagination.pageSize
    );
    const visibleIds = currentPageRows.map((row) => row.id);
    setVisibleRowIds(visibleIds);

    // If there are no visible rows, set SelectAllChecked to false
    if (visibleIds.length === 0) {
      setIsSelectAllChecked(false);
      setIsIndeterminate(false);
      return;
    }

    // Check if all visible rows are selected
    const allVisibleSelected = visibleIds.every((id) =>
      selectedid.includes(id)
    );
    const someVisibleSelected = visibleIds.some((id) =>
      selectedid.includes(id)
    );

    setIsSelectAllChecked(allVisibleSelected);
    setIsIndeterminate(someVisibleSelected && !allVisibleSelected);
  }, [pagination, campaignreportData, selectedid]);

  // HandleSelectAllCheckBox
  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      // Select all visible row IDs
      setSelectedid((prevSelectedIds) => [
        ...new Set([...prevSelectedIds, ...visibleRowIds]),
      ]);
    } else {
      // Deselect all visible row IDs
      setSelectedid((prevSelectedIds) =>
        prevSelectedIds.filter((id) => !visibleRowIds.includes(id))
      );
    }
  };

  // Individual CheckBox
  const handleCheckboxChange = (event, id) => {
    const checked = event.target.checked;

    setSelectedid((prevSelectedIds) => {
      if (checked) {
        const newSelected = [...prevSelectedIds, id];
        // Check if all visible rows are selected after this checkbox is checked
        const allVisibleSelected = visibleRowIds.every((rowId) =>
          newSelected.includes(rowId)
        );
        setIsSelectAllChecked(allVisibleSelected);
        setIsIndeterminate(!allVisibleSelected);

        return newSelected;
      } else {
        // Deselect the row ID
        const newSelected = prevSelectedIds.filter((rowId) => rowId !== id);
        setIsSelectAllChecked(false);
        setIsIndeterminate(
          visibleRowIds.some((rowId) => newSelected.includes(rowId))
        );

        return newSelected;
      }
    });
  };

  // Select All Row
  const handleSelectAllData = () => {
    if (campaignreportData.length === selectedid.length) {
      setSelectedid([]);
    } else {
      const allRowIds = campaignreportData.map((row) => row.id);
      setSelectedid(allRowIds);
    }
  };

  // Select EnquiryIds
  useEffect(() => {
    if (selectedid.length > 0) {
      const enquiryIds = campaignreportData.filter((id) =>
        selectedid.includes(id?.id)
      );
      const selectedEnquiryids = enquiryIds.map((i) => i.enquiry_id?.id);
      setSelectedEnquiryids(selectedEnquiryids);
    }
  }, [selectedid]);

  const columns = [
    {
      field: "selection",
      sortable: false,
      disableColumnMenu: true,

      renderHeader: (params) => (
        <Checkbox
          size="small"
          checked={isSelectAllChecked}
          indeterminate={isIndeterminate}
          onChange={handleSelectAllChange}
        />
      ),
      headerClassName: "header-cell",
      width: 70,
      renderCell: (params) => {
        const isChecked = selectedid.includes(params.row?.id);
        return (
          <Checkbox
            size="small"
            checked={isChecked}
            onChange={(event) => handleCheckboxChange(event, params.row?.id)}
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",

      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.first_name || ""}{" "}
          ${params.row?.enquiry_id?.last_name || ""}`,
      renderCell: (params) => (
        <div
          style={{ color: "#2196F3", cursor: "pointer" }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row?.enquiry_id?.id}`,
              "_blank"
            )
          }
        >
          {params.row?.enquiry_id?.first_name}{" "}
          {params.row?.enquiry_id?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "phone",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.enquiry_id?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.enquiry_id?.mobile}
        </div>
      ),
    },
    {
      field: "enquiry_date",
      headerName: "Enquiry Date",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.enquiry_id?.enquiry_date || ""}`,

      renderCell: (params) => <div>{params.row?.enquiry_id?.enquiry_date}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "contact",
      headerName: "Contact",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.connected_call || ""}`,

      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.connected_call}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "nonContact",
      headerName: "Non Contact",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.not_connected_call || ""} `,

      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.not_connected_call}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "openTask",
      headerName: "Open Task",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.total_open_task || ""} `,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.total_open_task}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "leadOwner",
      headerName: "Lead Owner",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.assign_to?.first_name || ""}{" "}
          ${params.row?.assign_to?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.assign_to?.first_name} {params.row?.assign_to?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "campaign",
      headerName: "Campaign",
      width: 450,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.campaign_id?.campaign_name || ""} `,
      renderCell: (params) => (
        <div> {params.row?.campaign_id?.campaign_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "branch",
      headerName: "Branch",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.branch_id?.branch_name || ""} `,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.branch_id?.branch_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "service",
      headerName: "Service",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.service_id?.service_name || ""} `,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.service_id?.service_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subService",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.sub_service_id?.name || ""} `,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.sub_service_id?.name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "stage",
      headerName: "Stage",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.stage_id?.stage_name || ""} `,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.stage_id?.stage_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.enquiry_id?.is_active || ""} `,
      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.is_active === 1 ? (
            <Chip
              variant="contained"
              size="small"
              color="secondary"
              label="active"
            />
          ) : params.row?.enquiry_id?.is_active === 0 ? (
            <Chip
              size="small"
              variant="contained"
              color="error"
              label="inactive"
            />
          ) : (
            ""
          )}
        </div>
      ),
      sortComparator: (v1, v2, cellParams1, cellParams2) => {
        const isActive1 = cellParams1.row?.enquiry_id?.is_active;
        const isActive2 = cellParams2.row?.enquiry_id?.is_active;

        // Sort based on 'is_active' value (1 for active, 0 for inactive)
        return isActive1 - isActive2;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "firstcountry",
      headerName: "First Country of Interest",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.target_country_id?.country_name || ""} `,
      renderCell: (params) => (
        <div>{params?.row?.enquiry_id?.target_country_id?.country_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "leadSource",
      headerName: "Lead Source",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.lead_source_type_id?.name || ""}`,

      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.lead_source_type_id?.name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "prospective_level",
      headerName: "Prospective Level",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${
          params.row?.enquiry_id?.prospective_level_id?.prospective_level || ""
        }`,

      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.prospective_level_id?.prospective_level}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "state",
      headerName: "State Name",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.state_id?.state_name || ""}`,

      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.state_id?.state_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cityName",
      headerName: "City Name",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.city_id?.city_name || ""}`,

      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.city_id?.city_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.createdAt || ""}`,

      renderCell: (params) => <div>{fDateTime(params.row?.createdAt)}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "createdBy",
      headerName: "Created By",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.created_by?.first_name || ""}{" "}
          ${params.row?.created_by?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.created_by?.first_name}{" "}
          {params.row?.created_by?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "registrationStatus",
    //   headerName: "Registration Status",
    //   width:150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div></div>,
    //   headerAlign: "center",
    //   align: "center",
    // },
    // {
    //   field: "visit",
    //   headerName: "Visit Status",
    //   width:150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div></div>,
    //   headerAlign: "center",
    //   align: "center",
    // },
    {
      field: "nearestBranch",
      headerName: "Nearest Branch",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.nearest_branch_id?.branch_name || ""}`,

      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.nearest_branch_id?.branch_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "last_follow_up_date",
      headerName: "Last follow up date",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.last_follow_up_date || ""}`,

      renderCell: (params) => (
        <div>{params?.row?.enquiry_id?.last_follow_up_date}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "next_follow_up_date",
      headerName: "Next follow up date",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.next_follow_up_date || ""}`,

      renderCell: (params) => (
        <div>{params?.row?.enquiry_id?.next_follow_up_date}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    // {
    //   field: "re_status",
    //   headerName: "Registration Status",
    //   width: 150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div></div>,
    //   headerAlign: "center",
    //   align: "center",
    // },

    // {
    //   field: "v_status",
    //   headerName: "Visit Status",
    //   width: 150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div></div>,
    //   headerAlign: "center",
    //   align: "center",
    // },
    // {
    //   field: "intake",
    //   headerName: "Intake",
    //   width:150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div></div>,
    //   headerAlign: "center",
    //   align: "center",
    // },
    // {
    //   field: "coAssignee",
    //   headerName: "Co-Assignee",
    //   width:150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div></div>,
    //   headerAlign: "center",
    //   align: "center",
    // },
    // {
    //   field: "permanentAssignee",
    //   headerName: "Permanent Assignee",
    //   width:150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div></div>,
    //   headerAlign: "center",
    //   align: "center",
    // },
  ];
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Available</Box>
      </StyledGridOverlay>
    );
  }

  useEffect(() => {
    const fetchData = async () => {
      setCampaignLoading(true);
      const token = getTokenOrLogout();
      if (!token) return;
      let headers = {
        Authorization: `Bearer ${token}`,
      };
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/gettodayenquiry/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          if (data.length === 0) {
            showSnackbar("No any data vailable for today", "error");
            setCampaignLoading(false);
          } else {
            setCampaignreportData(sortedData);
            setOriginalData(sortedData);
            setcampaignRowData(sortedData);
            setCampaignLoading(false);
          }
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 440) {
          navigate("/page440");
        } else {
          navigate("/page500");
        }
      } catch (error) {
        navigate("/page500");
      }
    };
    fetchData();
  }, [userId]);

  const handleOpenmask = () => {
    setOpenMask(true);
  };

  const handleClosemask = () => {
    setOpenMask(false);
  };

  const handleOpenEmail = () => {
    setOpenEmailPopup(true);
  };

  const handleCloseEmail = () => {
    setOpenEmailPopup(false);
  };

  useEffect(() => {
    fetch(`${API_ENDPOINT}route/downloadaccess/${userId}`)
      .then((response) => {
        if (response.ok) {
          setIsDownloadAccess(true);
        } else {
          setIsDownloadAccess(false);
        }
      })
      .catch((err) => {
        setIsDownloadAccess(false);
      });
  }, [userId]);

  useEffect(() => {
    const exportData = campaignreportData.map((row) => ({
      name: row.enquiry_id?.last_name
        ? `${row.enquiry_id.first_name} ${row.enquiry_id.last_name}`
        : row.enquiry_id.first_name,
      mobile: row.enquiry_id.mobile,
      contactable: row.enquiry_id.connected_call || "",
      non_contactable: row.enquiry_id.not_connected_call || "",
      open_tasks: row.enquiry_id.total_open_task || "",
      nearest_branch: row.enquiry_id?.nearest_branch_id?.branch_name || "",
      enquiry_date: row.enquiry_id.enquiry_date
        ? fDate(row.enquiry_id.enquiry_date)
        : "",
      last_followup_date: row.enquiry_id.last_follow_up_date
        ? row.enquiry_id.last_follow_up_date
        : "",
      next_followup_date: row.enquiry_id.next_follow_up_date
        ? fDate(row.enquiry_id.last_follow_up_date)
        : "",
      campaign_name: row.campaign_id?.campaign_name,
      prospective_level:
        row.enquiry_id?.prospective_level_id?.prospective_level || "",
      service: row.enquiry_id?.service_id?.service_name || "",
      sub_service: row.enquiry_id?.sub_service_id?.name || "",
      assign: row.enquiry_id?.assign_to?.first_name || "",
      lead_source_type: row.enquiry_id?.lead_source_type_id?.name || "",
      sub_lead_source_type:
        row.enquiry_id?.sub_lead_source_type_id?.source_type || "",
      stage: row.enquiry_id?.stage_id?.stage_name || "",
      branch: row?.enquiry_id?.branch_id?.branch_name || "",
      status:
        row.enquiry_id.is_active === 1
          ? "Active"
          : row.enquiry_id.is_active === 0
          ? "Inactive"
          : "",
      first_country_of_interest:
        row?.enquiry_id?.target_country_id?.country_name || "",
      state: row?.enquiry_id?.state_id?.state_name || "",
      city: row?.enquiry_id?.city_id?.city_name || "",
      created_at: fDateTime(row?.createdAt) || "",
      created_by: row.created_by?.last_name
        ? `${row.created_by?.first_name} ${row.created_by?.last_name}`
        : row.created_by?.first_name,
    }));
    setExportData(exportData);
  }, [campaignreportData]);

  // search all column in datagrid
  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = campaignRowData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data.enquiry_id?.first_name}
          ${data.enquiry_id?.last_name}`,
        `${data.enquiry_id?.mobile}`,
        `${data.enquiry_id?.enquiry_date}`,
        `${data?.assign_to?.first_name} ${data?.assign_to?.last_name}`,
        `${data?.campaign_id?.campaign_name}`,
        `${data?.enquiry_id?.branch_id?.branch_name}`,
        `${data?.enquiry_id?.service_id?.service_name}`,
        `${data?.enquiry_id?.sub_service_id?.name}`,
        `${data?.enquiry_id?.stage_id?.stage_name}`,
        `${
          data?.enquiry_id?.enquiry_id?.is_active === 1 ? "active" : "inactive"
        }`,
        `${data?.enquiry_id?.lead_source_type_id?.name}`,
        `${data?.enquiry_id?.prospective_level_id?.prospective_level}`,
        `${data?.enquiry_id?.state_id?.state_name}`,
        `${data?.enquiry_id?.city_id?.city_name}`,
        `${data?.createdAt}`,
        `${data.created_by?.first_name}${data.created_by?.last_name}`,
        `${data?.enquiry_id?.nearest_branch_id?.branch_name}`,
        `${data?.enquiry_id?.last_follow_up_date}`,
        `${data?.enquiry_id?.next_follow_up_date}`,
        `${data?.enquiry_id?.target_country_id?.country_name}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setCampaignreportData(filteredData1); // Update the filtered data
  };

  // Removed Data from state after transfer
  const handleFilterdata = () => {
    const filteredData = campaignreportData.filter(
      (i) => !selectedEnquiryId.includes(i.enquiry_id?.id)
    );
    setCampaignreportData(filteredData);
    setTimeout(() => {
      setSelectedid([]);
      setSelectedEnquiryids([]);
    }, 1500);
  };

  console.log("selectedIds,", selectedid);

  const handletoggleStatus = () => {
    setOpenStatus(!openstatus);
  };

  const handletoggleStages = () => {
    setOpenStages(!openstages);
  };

  const handletoggLeval = () => {
    setLevalStatus(!levalStatus);
  };

  const totalConnectedCalls = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.connected_call !== 0 ? total + 1 : total;
  }, 0);

  const totalNotConnectedCalls = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.not_connected_call !== 0 ? total + 1 : total;
  }, 0);

  const totalNotAttemptedCalls = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.stage_id?.id === 1 ||
      item?.enquiry_id?.stage_id?.id === 2
      ? total + 1
      : total;
  }, 0);

  console.log("walkin",campaignRowData?.enquiry_id?.stage_id?.id === 1 )

  const totalOpenTask = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.total_open_task !== 0 ? total + 1 : total;
  }, 0);

  const totalNewlead = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.prospective_level_id?.prospective_level ===
      "New lead"
      ? total + 1
      : total;
  }, 0);

  const totalRecycled = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.prospective_level_id?.prospective_level ===
      "Recycled"
      ? total + 1
      : total;
  }, 0);

  const totalWarm = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.prospective_level_id?.prospective_level === "Warm"
      ? total + 1
      : total;
  }, 0);

  const totalHot = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.prospective_level_id?.prospective_level === "Hot"
      ? total + 1
      : total;
  }, 0);

  const totalContactInFuture = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.prospective_level_id?.prospective_level ===
      "Contact In Future"
      ? total + 1
      : total;
  }, 0);

  const totalSuperprospective = campaignRowData.reduce((total, item) => {
    return item?.enquiry_id?.prospective_level_id?.prospective_level ===
      "Super Prospective"
      ? total + 1
      : total;
  }, 0);

  const totalActiveCounselling = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "active counselling"
      ? total + 1
      : total;
  }, 0);

  const totalQualifyinf = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "qualifying"
      ? total + 1
      : total;
  }, 0);

  const totalAssignment = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "assignment"
      ? total + 1
      : total;
  }, 0);

  const totalBookDemo = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "book demo"
      ? total + 1
      : total;
  }, 0);

  const totalDemoCompleted = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "demo completed"
      ? total + 1
      : total;
  }, 0);

  const totalEnrolled = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "enrolled"
      ? total + 1
      : total;
  }, 0);

  const totalTraining = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "training"
      ? total + 1
      : total;
  }, 0);

  const totalTrainingCompleted = campaignRowData.reduce((total, item) => {
    return item.enquiry_id?.stage_id?.stage_name === "training completed"
      ? total + 1
      : total;
  }, 0);

  const handleResetselectedItem = () => {
    setSelectedEnquiryids([]);
    setVisibleRowIds([]);
    //  setSelectedFilters([]);
    setIsIndeterminate(false);
    setIsSelectAllChecked(false);
    setSelectedid([]);

    setPagination({ page: 0, pageSize: pagination.pageSize });
    setPrevPageSize(pagination.pageSize);
  };

  // Stages Clickable

  const handleFilterClick = (filterType, filterValue) => {
    handleResetselectedItem();
    setSelectedFilters((prevFilters) => {
      if (filterType === "stage") {
        // Clear all non-stage filters
        const stageFilters = prevFilters.filter((f) => f.type === "stage");

        const isSelected = stageFilters.some((f) => f.value === filterValue);

        if (isSelected) {
          // Deselect clicked stage
          return stageFilters.filter((f) => f.value !== filterValue);
        } else {
          // Add new stage and keep other selected stages
          return [...stageFilters, { type: "stage", value: filterValue }];
        }
      } else {
        // Prospective/contact status: only one at a time, clear everything
        const isAlreadySelected = prevFilters.some(
          (f) => f.type === filterType && f.value === filterValue
        );

        if (isAlreadySelected) {
          return []; // toggle off
        }

        return [{ type: filterType, value: filterValue }];
      }
    });
  };

  useEffect(() => {
    // If "Total" is selected, show all data
    const isTotalSelected = selectedFilters.some(
      (f) => f.type === "total" && f.value === "Total"
    );

    if (isTotalSelected) {
      setCampaignreportData(campaignRowData);
      return; // skip rest
    }

    // If other filters are selected
    if (selectedFilters.length > 0) {
      const filteredData = campaignRowData.filter((user) => {
        return selectedFilters.some((filter) => {
          if (filter.type === "stage") {
            return user.enquiry_id?.stage_id?.stage_name === filter.value;
          } else if (filter.type === "prospective") {
            return (
              user.enquiry_id?.prospective_level_id?.prospective_level ===
              filter.value
            );
          } else if (filter.type === "contact_status") {
            if (filter.value === "Contactable") {
              return user.enquiry_id?.connected_call !== 0;
            } else if (filter.value === "Not Contactable") {
              return user.enquiry_id?.not_connected_call !== 0;
            } else if (filter.value === "Open Task") {
              return user.enquiry_id?.total_open_task !== 0;
            } else if (filter.value === "Not Attempted") {
              return (
                user.enquiry_id?.stage_id?.id === 1 ||
                user.enquiry_id?.stage_id?.id === 2 
              );
            }
          }
          return false;
        });
      });

      setCampaignreportData(filteredData);
    } else {
      // No filters selected at all
      setCampaignreportData(campaignRowData);
    }
  }, [selectedFilters, campaignRowData]);

  return (
    <>
      <LoaderComp isLoading={campaignLoading} />

      <Grid container mb={2} spacing={2}>
        <Grid item lg={12}>
          <CampaignReportFilter
            open={open}
            setCampaignLoading={setCampaignLoading}
            campaignLoading={campaignLoading}
            setCampaignreportData={setCampaignreportData}
            originalData={originalData}
            setcampaignRowData={setcampaignRowData}
            setSelectedEnquiryids={setSelectedEnquiryids}
            setVisibleRowIds={setVisibleRowIds}
            setSelectedFilters={setSelectedFilters}
            setIsIndeterminate={setIsIndeterminate}
            setIsSelectAllChecked={setIsSelectAllChecked}
            setSelectedid={setSelectedid}
            setPagination={setPagination}
            setPrevPageSize={setPrevPageSize}
            pagination={pagination}
          />
        </Grid>

        <Grid item xs={12} lg={12} md={12} sm={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="end">
                <Grid container gap={2} justifyContent="end">
                  <MassTaskAssignButton onClick={handleOpenmask} />

                  <SendEmailButton onClick={handleOpenEmail} />

                  {isDownloadAccess && (
                    <CSVExport
                      data={exportData}
                      filename="campaign-report.csv"
                    />
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  style={{ cursor: "pointer" }}
                  onClick={handletoggleStatus}
                >
                  <Typography variant="h4">
                    {" "}
                    Task & Prospective Level Status{" "}
                  </Typography>
                  {!openstatus ? (
                    <KeyboardArrowDownIcon fontSize="small" />
                  ) : (
                    <KeyboardArrowUpIcon fontSize="small" />
                  )}
                </Box>{" "}
              </Grid>
              {openstatus && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      border: "1px solid #888888",
                      padding: "10px",
                      borderRadius: "10px",
                      display: "flex",
                      gap: 1,
                      flexWrap: "wrap",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) => f.type === "total" && f.value === "Total"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() => handleFilterClick("total", "Total")}
                    >
                      Total: {campaignRowData.length}
                    </Typography>
                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                        sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "contact_status" &&
                            f.value === "Contactable"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("contact_status", "Contactable")
                      }
                    >
                      Contactable: {totalConnectedCalls}
                    </Typography>
                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                        sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "contact_status" &&
                            f.value === "Not Contactable"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("contact_status", "Not Contactable")
                      }
                    >
                      Not Contactable: {totalNotConnectedCalls}
                    </Typography>
                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                        sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "contact_status" &&
                            f.value === "Not Attempted"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("contact_status", "Not Attempted")
                      }
                    >
                      Not Attempted: {totalNotAttemptedCalls}
                    </Typography>

                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                        sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "contact_status" &&
                            f.value === "Open Task"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("contact_status", "Open Task")
                      }
                    >
                      Open Task: {totalOpenTask}
                    </Typography>

                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                      sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "prospective" && f.value === "Recycled"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("prospective", "Recycled")
                      }
                    >
                      Recycle: {totalRecycled}
                    </Typography>
                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                      sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) => f.type === "prospective" && f.value === "Warm"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() => handleFilterClick("prospective", "Warm")}
                    >
                      Warm: {totalWarm}
                    </Typography>
                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                      sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "prospective" && f.value === "New lead"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("prospective", "New lead")
                      }
                    >
                      New Lead: {totalNewlead}
                    </Typography>
                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                      sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "prospective" &&
                            f.value === "Super Prospective"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("prospective", "Super Prospective")
                      }
                    >
                      Super Prospective: {totalSuperprospective}
                    </Typography>

                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                      sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) => f.type === "prospective" && f.value === "Hot"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() => handleFilterClick("prospective", "Hot")}
                    >
                      Hot: {totalHot}
                    </Typography>

                    <Box
                      sx={{ borderLeft: "1px solid #888888", height: "20px" }}
                    />

                    <Typography
                      variant="h6"
                      sx={{ cursor: "pointer" }}
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "prospective" &&
                            f.value === "Contact In Future"
                        )
                          ? "green"
                          : "black"
                      }
                      onClick={() =>
                        handleFilterClick("prospective", "Contact In Future")
                      }
                    >
                      Contact In Future: {totalContactInFuture}
                    </Typography>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12}>
                <Box
                  display="fles"
                  alignItems="center"
                  cursor="pointer"
                  style={{ cursor: "pointer" }}
                  onClick={handletoggleStages}
                >
                  <Typography variant="h4">Stages</Typography>
                  {!openstages ? (
                    <KeyboardArrowDownIcon fontSize="small" />
                  ) : (
                    <KeyboardArrowUpIcon fontSize="small" />
                  )}
                </Box>
                {openstages && (
                  <Grid container gap={1} mt={1}>
                    <OutlinedButtonComp
                      value={totalActiveCounselling}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) =>
                            f.type === "stage" &&
                            f.value === "active counselling"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "stage" &&
                            f.value === "active counselling"
                        )
                          ? "green"
                          : "black"
                      }
                      label="Active Counselling :"
                      margin="6px"
                      fontWeight="500"
                      onClick={() =>
                        handleFilterClick("stage", "active counselling")
                      }
                    />

                    <OutlinedButtonComp
                      value={totalQualifyinf}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "qualifying"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "qualifying"
                        )
                          ? "green"
                          : "black"
                      }
                      label="Qualifying :"
                      margin="6px"
                      onClick={() => handleFilterClick("stage", "qualifying")}
                    />

                    <OutlinedButtonComp
                      value={totalAssignment}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "assignment"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "assignment"
                        )
                          ? "green"
                          : "black"
                      }
                      label="Assignment :"
                      margin="6px"
                      onClick={() => handleFilterClick("stage", "assignment")}
                    />

                    <OutlinedButtonComp
                      value={totalBookDemo}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "book demo"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "book demo"
                        )
                          ? "green"
                          : "black"
                      }
                      label=" Book demo :"
                      margin="6px"
                      onClick={() => handleFilterClick("stage", "book demo")}
                    />

                    <OutlinedButtonComp
                      value={totalDemoCompleted}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) =>
                            f.type === "stage" && f.value === "demo completed"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "stage" && f.value === "demo completed"
                        )
                          ? "green"
                          : "black"
                      }
                      label="Demo completed :"
                      margin="6px"
                      onClick={() =>
                        handleFilterClick("stage", "demo completed")
                      }
                    />

                    <OutlinedButtonComp
                      value={totalEnrolled}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "enrolled"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "enrolled"
                        )
                          ? "green"
                          : "black"
                      }
                      label="Enrolled :"
                      margin="6px"
                      onClick={() => handleFilterClick("stage", "enrolled")}
                    />

                    <OutlinedButtonComp
                      value={totalTraining}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "training"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) => f.type === "stage" && f.value === "training"
                        )
                          ? "green"
                          : "black"
                      }
                      label=" Training :"
                      margin="6px"
                      onClick={() => handleFilterClick("stage", "training")}
                    />

                    <OutlinedButtonComp
                      value={totalTrainingCompleted}
                      borderRadius="25px"
                      borderColor={
                        selectedFilters.some(
                          (f) =>
                            f.type === "stage" &&
                            f.value === "training completed"
                        )
                          ? "green"
                          : "#b2b2b4"
                      }
                      color={
                        selectedFilters.some(
                          (f) =>
                            f.type === "stage" &&
                            f.value === "training completed"
                        )
                          ? "green"
                          : "black"
                      }
                      label="  Training Completed : "
                      margin="6px"
                      onClick={() =>
                        handleFilterClick("stage", "training completed")
                      }
                    />
                  </Grid>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                container
                gap={1}
                alignItems="center"
              >
                <Chip
                  label={
                    campaignreportData.length !== selectedid.length ||
                    campaignreportData.length === 0
                      ? "Select All"
                      : "Deselect All"
                  }
                  variant="outlined"
                  size="small"
                  onClick={() => handleSelectAllData()}
                />
                <SelectedItemButton value={selectedid.length} />
              </Grid>

              <Grid item xs={12} sm={12} md={6} textAlign="end">
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>

<Grid item xs={12}>
              <DataGrid
                rows={campaignreportData}
                columns={columns}
                autoHeight
                slots={{
                  noRowsOverlay: CustomNoRowsOverlay,
                }}
                paginationModel={pagination}
                onPaginationModelChange={(model) => setPagination(model)}
           
                pageSizeOptions={[10, 25, 50, 100]}
              />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      {selectedid.length === 0 ? (
        <CustomPopup
          open={openMask}
          onClose={handleClosemask}
          component={<NoenquiryForm onClose={handleClosemask} />}
          maxWidth="xs"
        />
      ) : (
        <CustomPopup
          open={openMask}
          onClose={handleClosemask}
          component={
            <MassTaskAssign
              onClose={handleClosemask}
              selectedEnquiryIds={selectedEnquiryId}
              setSelectedEnquiryIds={setSelectedEnquiryids}
              handleFilterdata={handleFilterdata}
            />
          }
          title="Mass Task Assign"
          maxWidth="md"
          showDivider={true}
        />
      )}

      {selectedid.length === 0 ? (
        <CustomPopup
          open={OpenEmailPopup}
          onClose={handleCloseEmail}
          component={<NoeMailForm onClose={handleCloseEmail} />}
          maxWidth="xs"
        />
      ) : (
        <BulkEmailPopup
          open={OpenEmailPopup}
          handelclose={handleCloseEmail}
          component={
            <BulkMailform
              handelclose={handleCloseEmail}
              selectedId={selectedEnquiryId}
            />
          }
          title="Send Bulk Emails"
          maxWidth="md"
          showDivider={true}
        />
      )}

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
